import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import ViewportContext from '../../../../components/viewport/context';

import * as S from './styles';

type SotyBanner = {
  year: string;
};

const SotyBadge = ({ year }: SotyBanner) => {
  const { t, market } = useContext(AppContext);
  return (
    <S.Badge>
      <img
        src={`${market.cdn}/g/store_of_the_year/${year}/${market.code}/award/dark/main_award.png`}
        alt={t('campaigns', 'shop-of-the-year.title-with-year', {
          year,
        })}
      />
    </S.Badge>
  );
};

const SotyContent = () => {
  const { t, linkTo } = useContext(AppContext);

  const SotyLink = <Link to={linkTo('shopOfTheYear', {})} />;

  return (
    <S.Content>
      <p>{t('campaigns', 'shop-of-the-year.leaderboard-description')}</p>
      <S.Link component={SotyLink}>
        {t('campaigns', 'shop-of-the-year.vote-for-favorite')}
      </S.Link>
    </S.Content>
  );
};

const SotyTitle = () => {
  const { t } = useContext(AppContext);
  return <h2>{t('campaigns', 'shop-of-the-year.leaderboard-title')}</h2>;
};

const SotyBannerMobile = ({ year }: SotyBanner) => (
  <S.Banner>
    <S.Header>
      <SotyBadge year={year} />
      <SotyTitle />
    </S.Header>
    <SotyContent />
  </S.Banner>
);

const SotyBannerDesktop = ({ year }: SotyBanner) => (
  <S.Banner>
    <SotyBadge year={year} />
    <div>
      <S.Header>
        <SotyTitle />
      </S.Header>
      <SotyContent />
    </div>
  </S.Banner>
);

export default ({ year }: SotyBanner) => {
  const { isMobile } = useContext(ViewportContext);

  return isMobile ? (
    <SotyBannerMobile year={year} />
  ) : (
    <SotyBannerDesktop year={year} />
  );
};
